var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500001 12C0.500002 5.64873 5.64873 0.5 12 0.500001C18.3513 0.500001 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.500001 12Z",
    stroke: "#ED9373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6551 12.6562C17.0969 12.6562 17.4551 12.2981 17.4551 11.8563C17.4551 11.4144 17.0969 11.0563 16.6551 11.0563L7.05508 11.0563C6.61325 11.0563 6.25508 11.4144 6.25508 11.8563C6.25508 12.2981 6.61325 12.6562 7.05508 12.6562L16.6551 12.6562Z",
    fill: "#ED9373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4196 16.0894C12.732 16.4018 12.732 16.9083 12.4196 17.2208C12.1072 17.5332 11.6006 17.5332 11.2882 17.2208L6.48822 12.4208C6.18536 12.1179 6.17476 11.6302 6.46418 11.3145L10.8642 6.5145C11.1627 6.1888 11.6688 6.1668 11.9945 6.46536C12.3202 6.76391 12.3422 7.26996 12.0436 7.59566L8.16122 11.831L12.4196 16.0894Z",
    fill: "#ED9373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowImage);
export default __webpack_public_path__ + "static/media/arrow-image.74a25f0010ce845c7d13fd22b31da97b.svg";
export { ForwardRef as ReactComponent };